import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Messages } from 'primereact/messages';
import { ProgressBar } from 'primereact/progressbar';
import Container from 'react-bootstrap/Container';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../config.js';
import SupportResourcesContent from './SupportResourcesContent';

const SupportResources = () => {
	const navigate = useNavigate();
	const { logout } = useAuth();
	const msgs = useRef(null);

	const [loading, setLoading] = useState(true);
	const [lms, setLms] = useState('');

	const appid = localStorage.getItem('appid');
	const cid = localStorage.getItem('id');

	useEffect(() => {
		const load = async () => {
			try {
				setLoading(true);
				if (msgs.current) msgs.current.clear();

				const token = localStorage.getItem('token');
				const id = localStorage.getItem('id');
				if (!token || !id) {
					navigate('/login');
					return;
				}

				let urlLms = global.config.url + `/support/lms/${id}`;
				if (appid !== null && appid !== undefined && String(appid) !== '') {
					urlLms = urlLms + `?appProviderId=${appid}`;
				}

				const lmsResponse = await axios.get(urlLms, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				});

				if (lmsResponse.status === 200 && lmsResponse.data && lmsResponse.data.key) {
					setLms(lmsResponse.data.key);
				} else {
					setLms('');
				}
			} catch (error) {
				console.error('Error loading support resources:', error);
				if (error.response && (error.response.status === 401 || error.response.status === 403)) {
					await logout();
					navigate('/login');
					return;
				}
				if (msgs.current) {
					msgs.current.show({
						severity: 'error',
						summary: '',
						detail: 'Failed to load resources. Please try again.',
					});
				}
			} finally {
				setLoading(false);
			}
		};

		load();
	}, [navigate, logout, appid]);

	return (
		<Card className="justify-content-md-center mt-5">
			<Container fluid="md">
				<div className="panel">
					<div className="flex align-content-center flex-wrap">
						<Button link icon="pi pi-arrow-left" onClick={() => navigate(-1)} className="flex mb-3" />
						<h4 className="flex mt-2 mb-3">Resources</h4>
					</div>
				</div>
				<Messages ref={msgs} />
				{loading && (
					<div className="card mt-3">
						<ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar>
					</div>
				)}
				<div className="mt-3">
					<SupportResourcesContent appid={appid} cid={cid} lms={lms} />
				</div>
			</Container>
		</Card>
	);
};

export default SupportResources;
